var auctionWebSocketModule = (function() {

  var listeners = [];
  var url = servicesUrl + '/websocket/auctions';
  var accountUrl = servicesUrl + '/websocket/user';

  var auctionWebSocketClient;
  var accountAuctionsWebSocketClient;

  // generic public auction socket wrapper
  function AuctionWebSocketClient(url) {
    var websocketClient = new WebSocketClient(url);
    var client = {
      connect: function() {
        return websocketClient.connect().then(function(frame) {
          return frame.headers['user-name'];
        });
      },
      disconnect: function() {
        websocketClient.disconnect();
      },
      fetchMessages: function(callback) {
        return websocketClient.subscribe('/messages/auction/updates', callback);
      },
      fetchErrorStream: function(callback) {
        return websocketClient.subscribe('/messages/errors', callback);
      },
      isDisconnected: function() {
        return websocketClient.isDisconnected();
      }
    }

    return client;
  }

  // account specific auction socket wrapper
  function AccountAuctionsWebSocketClient(url) {
    var websocketClient = new WebSocketClient(accountUrl);
    var client = {
      connect: function() {
        return websocketClient.connect().then(function(frame) {
          return frame.headers['user-name'];
        });
      },
      disconnect: function() {
        websocketClient.disconnect();
      },
      fetchMessages: function(callback) {
        return websocketClient.subscribe('/user/messages/messages/auction/updates', callback);
      },
      fetchErrorStream: function(callback) {
        return websocketClient.subscribe('/messages/errors', callback);
      },
      isDisconnected: function() {
        return websocketClient.isDisconnected();
      }
    }

    return client;
  }

  function getAuctionMessages() {
    console.log('Connecting... ');
    auctionWebSocketClient = new AuctionWebSocketClient(url);

    auctionWebSocketClient.connect()
      .then(function() {
          console.log('Connected... Notifications will appear.');

          auctionWebSocketClient.fetchMessages(function(json) {
            handleSocketMessage(json);
          });
          auctionWebSocketClient.fetchErrorStream(function(json) {
            console.warn(json);
          });
        },
        function(error) {
          console.error(error);
        });
  }

  function getAccountMessages() {
    console.log('Connecting... ');
    accountAuctionsWebSocketClient = new AccountAuctionsWebSocketClient(url);

    accountAuctionsWebSocketClient.connect()
      .then(function() {
          console.log('Connected... Notifications will appear.');

          accountAuctionsWebSocketClient.fetchMessages(function(json) {
            handleSocketMessage(json);
          });
          accountAuctionsWebSocketClient.fetchErrorStream(function(json) {
            console.warn(json);
          });
        },
        function(error) {
          console.error(error);
        });
  }

  function checkIfStartClient() {
    if (auctionWebSocketClient != null && auctionWebSocketClient.isDisconnected()) {
      console.log('Socket is disconnected...');
      getAuctionMessages();
    } else if (auctionWebSocketClient == null) {
      console.log('Socket is initiated...');
      getAuctionMessages();
    }

    /*
    if (isLoggedIn()) {
      if (accountAuctionsWebSocketClient != null && accountAuctionsWebSocketClient.isDisconnected()) {
        console.log('Account Socket is disconnected...');
        getAccountMessages();
      } else if (accountAuctionsWebSocketClient == null) {
        console.log('Account Socket is initiated...');
        getAccountMessages();
      }
    }
    */
  }

  function handleSocketMessage(message) {
    console.log(message);
    for (listener of listeners) {
      listener(message);
    }
  }

  setInterval(function() {
    // try reconnecting every 2 seconds if disconnected and only if window is active
    if (!document.hidden && flagAuctionsEnabled && getLocation() == 1) {
      var path = document.location.pathname;
      var pageHasAuction = (flagAuctionsVisible && path == '/') || path.indexOf('/auctions') >= 0;

      if (pageHasAuction) {
        checkIfStartClient();
      }
    }
  }, 2000);

  function addListener(cb) {
    if (typeof cb === 'function') {
      console.log('Adding listener');
      listeners.push(cb);
    }
  }

  return {
    addListener: addListener
  }

}());

/* Add for mocha testing */
// Basically it make the auctionWebSocketModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = auctionWebSocketModule;
}